import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./user";
import authReducer from "./auth";

const store = configureStore({
  reducer: {
    user: userReducer,
    auth: authReducer,
  },
});

export default store;
